export default "__VITE_ASSET__CX9tmHrT__"